module.exports = __webpack_public_path__ + "static/img/年度最佳平板电脑.025a23cd.png";